var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOperations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(794.984 -23838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M41.07,30.37a12.1,12.1,0,0,0-1.775-4.158l1.422-1.468L36.938,21.1l-1.422,1.462a12.27,12.27,0,0,0-3.8-1.542V18.983H26.459v2.036A12.106,12.106,0,0,0,22.3,22.795l-1.468-1.422-3.644,3.778,1.462,1.422a12.235,12.235,0,0,0-1.555,3.8H15.073V35.63h2.036a12.1,12.1,0,0,0,1.775,4.158l-1.422,1.468L21.24,44.9l1.422-1.462a12.234,12.234,0,0,0,3.8,1.555v2.022h5.253V44.981a12.1,12.1,0,0,0,4.158-1.775l1.468,1.422,3.644-3.778-1.462-1.422a12.232,12.232,0,0,0,1.555-3.8h2.022V30.37Zm-6.881,3.9a4.709,4.709,0,0,1-.554,1.355,5.171,5.171,0,0,1-1.915,1.916,4.681,4.681,0,0,1-1.175.5,4.885,4.885,0,0,1-1.455.207,5.084,5.084,0,0,1-1.268-.16,4.715,4.715,0,0,1-1.355-.554,5.173,5.173,0,0,1-1.916-1.916,4.685,4.685,0,0,1-.5-1.175,4.872,4.872,0,0,1-.207-1.448A5.081,5.081,0,0,1,24,31.725a4.715,4.715,0,0,1,.554-1.355,5.173,5.173,0,0,1,1.916-1.916,4.685,4.685,0,0,1,1.175-.5,4.875,4.875,0,0,1,1.448-.207,5.08,5.08,0,0,1,1.268.16,4.715,4.715,0,0,1,1.355.554,5.172,5.172,0,0,1,1.915,1.916,4.681,4.681,0,0,1,.5,1.175,5.055,5.055,0,0,1,.053,2.717Z",
    transform: "translate(-808.073 23821)",
    fill: "#8e50a7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOperations);
export default __webpack_public_path__ + "static/media/icon-operations.5ec91b1a9b6f11a1cbc980a22b4cbc25.svg";
export { ForwardRef as ReactComponent };